import document from 'document';

import { eventBus } from '../../foundation/eventBus';
import { events as formEvents } from '../../feature/form/enable-form';
import { elementOffset } from '../scc/element-offset';
import { ajaxRequest } from '../../utilities/ajax';
import { slideDown } from '../../utilities/slide-down';

export const  addressFinder = () => {
        
    let config = {};
    
    let _selectors = {};

    const _makeRequest = (service, dataObj, callBack) => {
        
        const request = ajaxRequest.jsonp(service.url, dataObj);
        
        request.then((data) => {
            if (data.Items.length && data.Items[0].Error) {
                const dataMessage = data.Items[0];
                console.warn('Error: ' + dataMessage.Error + ', ' + dataMessage.Description + ', ' + dataMessage.Cause + ', ' + dataMessage.Resolution);
            } else {
                if (typeof callBack != 'function') {
                    console.warn(callBack + ' is not a function');
                } else {
                    callBack(data);
                }
            }
        }).catch((error) => {
            if (error) {
                console.warn('Error: ' + error);
            }
        });
        
    };

    const _findAddress = (text, addAddressListHandler) => {
        if (text != null || text != '') {
            const findArr = [{
                url: config.findService
            }, {
                key: config.key,
                country: config.country,
                // this can be GB (single) or GB, US, CA
                searchTerm: text
            }, function createResultList(data) {
                const items = data.Items.map((suggestion) => {
                    return {
                        label: suggestion.Text,
                        value: '',
                        data: suggestion
                    };
                });
                _createHtmlResultsContainer(items, () => { 
                    _createHtmlResultsList(items);

                    addAddressListHandler();
                });
            }];

            _makeRequest.apply(null, findArr);
        }
    };

    const _retrieveAddress = (id) => {
        if (id != null || id != '') {
            const retrieveArr = [{
                url: config.receiveService
            }, {
                key: config.key,
                id: id
            }, function clearResults(data) {
                if (data.Items.length) {
                    _clearResultsContainer();
                    _hideEnterManualField();
                    _showHiddenField();
                    _populateAddress(data);
                }
            }];

            _makeRequest.apply(null, retrieveArr);
        }
    };

    const _createHtmlResultsContainer = (resultItems, callBack) => {
        const container = document.querySelector(_selectors.resultsContainer);
        if (resultItems.length) {
            container.innerHTML = '<ul class="address-search__' + _selectors.context + '__results ' + _selectors.addressList + '" size="4" />';            
        } else {
            container.innerHTML = '<div class="address-search__no-results">Sorry no results found.</div>';  
        }
        container.style.display = 'block';
        callBack();
    };

    const _clearResultsContainer = () => {
        document.querySelector(_selectors.resultsContainer).style.display = 'none';
    };

    const _createHtmlResultsList = (items) => {
        const addressList = document.querySelector('.' + _selectors.addressList);
        for (let i = 0; i < items.length; i++) {
            const item = items[i];
            const label = item.label;
            const itemNext = item.data.Next;
            const itemId = item.data.Id;
            addressList.innerHTML = addressList.innerHTML + '<li class="address-search__result-item" data-value="' + label + '" title="' + label + '" data-next="' + itemNext + '" data-id="' + itemId + '"><span>' + label + '</span></li>'
        }
    };

    const _showHiddenField = () => {
        const hiddenFields = document.querySelector(_selectors.addressRoot).querySelector('.form-field-group__hidden-fields');

        if (!hiddenFields) return;

        if (hiddenFields) {
            const firstInput = hiddenFields.querySelector('input');
            slideDown(hiddenFields, 100);
            if (firstInput) {
                firstInput.focus();
            }
        }
    };

    const _hideEnterManualField = () => {
        document.querySelector(_selectors.addressRoot).querySelector('.js-show-hidden-field').style.display = 'none';
    };

    const _populateAddress = (data) => {

        if (data != null && data != {}) {
            
            const fields = Array.from(document.querySelector(_selectors.addressRoot).querySelectorAll(_selectors.field));
            const addressKeys = Object.keys(data.Items[0]);
            
            function populateField(key) {
                const field = fields.filter( (item) => {
                    const itemAttr = item.getAttribute('data-address-key');
                    if (itemAttr === key) {
                        return itemAttr;
                    }
                });
                
                const fieldElement = field[0];
            
                if (field.length > 0) {
                    if (data.Items[0][key]) {
                        fieldElement.parentElement.style.display = 'block';
                        fieldElement.value = data.Items[0][fieldElement.getAttribute('data-address-key')];
                        fieldElement.removeAttribute(_selectors.errorMessage);
                        fieldElement.classList.remove('visible');
                    } else {
                        fieldElement.parentElement.style.display = 'none';
                    }
                }
            }
            
            addressKeys.forEach(populateField);
        }
    };

    const _offsetAddressLookup = function(){            
        const element = document.querySelector(_selectors.resultsContainer);
        elementOffset().handleOffset(element);
    }

    const addressListHandler = (e) => {
        e.preventDefault();

        if (e.target && e.target.nodeName === 'SPAN') {
            const itemSelected = e.target.parentElement; 
            const itemText = itemSelected.getAttribute('data-value');

            if (itemSelected.getAttribute('data-next') !== 'Retrieve') {
                document.querySelector(_selectors.searchField).value = itemText;
                document.querySelector(_selectors.searchButton).dispatchEvent(new Event('click'));
            } else {
                _retrieveAddress(itemSelected.getAttribute('data-id'));
            }
        }
    };

    const _bindEvents = (el) => {
        el.querySelector(_selectors.searchButton).addEventListener('click', (e) => {
            e.preventDefault();
            const inputValue = document.querySelector(_selectors.searchField).value;

            if (inputValue) {
                _findAddress(inputValue, () => document.querySelector('.' +_selectors.addressList).addEventListener('click', addressListHandler));

                _offsetAddressLookup();
            }
        });

        eventBus.subscribe(formEvents.formSubmitted, () => {
            _showHiddenField();
        });

        el.querySelector('.js-show-hidden-field').addEventListener('click', (e) => {
            e.preventDefault();
            _showHiddenField();
            _hideEnterManualField();
        });

        document.addEventListener('keyup', (e) => {
            if (e.keyCode == 27) {
                _clearResultsContainer();
            }
        });
        document.addEventListener('click', () => _clearResultsContainer());
    };

    const _getSettings = (root, resolve) => {
        const pcaField = root.querySelectorAll(_selectors.searchField);
        
        if (pcaField.length > 0) {
            const element = pcaField[0];
            const data = {
                key: element.dataset.apiKey,
                findService: element.dataset.findService,
                receiveService: element.dataset.receiveService,
                country: element.dataset.country
            };
            config={...config, ...data};
            resolve(true);
        } else {
            console.warn('no data attributes or no values for each data attributes, please check your configuration');
        }
    };

    const init = (selectors) => {
        _selectors = selectors;

        const root = document.querySelectorAll(_selectors.addressRoot)[0];
        if (root && root.querySelectorAll(_selectors.searchField).length) {  
            const readSettings = new Promise((resolve) => {
              _getSettings(root, resolve);
            });
            readSettings    
            .then(() => {
                _bindEvents(root);
            });
        }
    };

    return {
        init: init
    };
};
